import { Middleware } from "@reduxjs/toolkit";
import { RootState } from "..";
import {
  setDrive,
  setDriveWithValidation,
  setDriveStats,
  addDrive,
  removeDrive,
  updateDriveRole,
} from "../features/shipBuilderSlice";
import { calculateDriveStats } from "../../utils/calculations/driveCalculations";

const driveStatsMiddleware: Middleware<{}, RootState> =
  (store) => (next) => (action: any) => {
    // First, let the action pass through and update the state
    const result = next(action);

    // Now, check if this is one of the actions we care about
    if (setDrive.match(action) || setDriveWithValidation.match(action) || addDrive.match(action) || removeDrive.match(action) || updateDriveRole.match(action)) {
      // Get the *new* state after the reducers have run
      const state = store.getState().shipBuilder;
      const { drives, shipSize } = state;

      // Skip calculation if state is not properly initialized
      if (!shipSize || shipSize <= 0) {
        console.log("driveStatsMiddleware: Skipping calculation - ship size not initialized");
        return result;
      }

      const calculationInput = {
        drives,
        shipSize,
      };

      const statsResult = calculateDriveStats(calculationInput);

      if (statsResult.success && statsResult.data) {
        store.dispatch(setDriveStats(statsResult.data));
      }
    }

    return result;
  };

export default driveStatsMiddleware;
